import { render, staticRenderFns } from "./Countries.vue?vue&type=template&id=3436afb3&"
import script from "./Countries.vue?vue&type=script&lang=js&"
export * from "./Countries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Countries.vue"
export default component.exports